<template>
  <div>
    <WidgetsDropdown/>
    <CCard>
      <CCardBody>
        <CRow>
          <CCol sm="5">
            <h4 id="traffic" class="card-title mb-0">Statistics</h4>
            <div class="small text-muted">{{ thisMonth}}</div>
          </CCol>
          <CCol sm="7" class="d-none d-md-block">
            <!--<CButton color="primary" class="float-right">
              <CIcon name="cil-cloud-download"/>
            </CButton>-->
            <CButtonGroup class="float-right mr-3">
              <CButton
                color="outline-secondary"
                v-for="(value, key) in ['Day', 'Week', 'Month']"
                :key="key"
                class="mx-0"
                :pressed="value === selected ? true : false"
                @click="selected = value"
              >
                {{value}}
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
        <MainChart :yLabels="yLabels" :datasets="datasets" :max="max" :stepSize="stepSize" style="height:300px;margin-top:40px;"/>
      </CCardBody>
      <CCardFooter>
        <CRow class="text-center">
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Visitors</div>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="secondary"
              :value="100"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Requests</div>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="success"
              :value="100"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
            <div class="text-muted">Downloads</div>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="info"
              :value="100"
            />
          </CCol>
          
        </CRow>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import MainChart from './MainChart'
import WidgetsDropdown from './WidgetsDropdown'
import { getStyle, hexToRgba } from '@coreui/utils/src'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import firebase from "firebase/app";
import firestore from "firebase/firestore";

function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export default {
  name: 'Dashboard',
  components: {
    MainChart,
    WidgetsDropdown
  },
  created() {
    this.thisMonth = new Date().toLocaleString('zh-TW',{ year: 'numeric', month: 'long', timeZone: 'Asia/Taipei'});
    this.selected = 'Day';
  },
  data () {
    return {
      thisMonth : 'N/a',
      selected: '',
      yLabels: [],
      datasets: [],
      max: 50,
      stepSize: Math.ceil(50 / 5),
    }
  },
  watch: {
    selected: async function (value) {
     dayjs.extend(utc);
     dayjs.extend(timezone);
     var db = firebase.firestore();
  
     const brandSuccess = getStyle('success') || '#4dbd74'
     const brandInfo = getStyle('info') || '#20a8d8'
     const brandDanger = getStyle('secondary') || '#ced2d8'
     const data1 = []
     const data2 = []
     const data3 = []

     let newYLabels = [];
     if(value === 'Day'){
      this.max = 20;
      this.stepSize = 5;
      let date = dayjs().tz("Asia/Taipei"); 
      let statRefs = db.collection("daily");
      let start = dayjs().tz("Asia/Taipei").subtract(28,'day');
      let end = dayjs().tz("Asia/Taipei").subtract(1,'day');
      statRefs = statRefs.where("date", ">=", start.format('YYYY-MM-DD'));
      statRefs = statRefs.where("date", "<=", end.format('YYYY-MM-DD'));
      statRefs = statRefs.orderBy("date", "asc");
      let data = {};
      let allCol = await statRefs.get();
      allCol.forEach(function(doc){
        let daily = doc.data();
        data[dayjs(daily.date, "YYYY-MM-DD").format('M/D')] = daily;
      });

       for(let i = 1 ; i <= 28; i++){
         let label = date.subtract(i, 'day').format('M/D');
         newYLabels.push(label);
         if(data[label]){
           data3.push(data[label].visitors);
           data2.push(data[label].requests);
           data1.push(data[label].downloads);
         }else{
           data3.push(0);
           data2.push(0);
           data1.push(0);
         }
       }
       this.yLabels = newYLabels.reverse();
     }else if (value === 'Week') {
       this.max = 50;
      this.stepSize = 10;
      let date = dayjs().tz("Asia/Taipei").startOf('week');
      let statRefs = db.collection("weekly");
      let start = dayjs().tz("Asia/Taipei").subtract(21,'week');
      let end = dayjs().tz("Asia/Taipei").subtract(1,'week');
      statRefs = statRefs.where("date", ">=", start.format('YYYY-MM-DD'));
      statRefs = statRefs.where("date", "<=", end.format('YYYY-MM-DD'));
      statRefs = statRefs.orderBy("date", "asc");
      let data = {};
      let allCol = await statRefs.get();
      allCol.forEach(function(doc){
        let daily = doc.data();
        data[dayjs(daily.date, "YYYY-MM-DD").format('M/D')] = daily;
      });
      for(let i = 1 ; i < 21; i++){
        let label = date.subtract(i, 'week').format('M/D');
         newYLabels.push(label);
          if(data[label]){
           data3.push(data[label].visitors);
           data2.push(data[label].requests);
           data1.push(data[label].downloads);
         }else{
           data3.push(0);
           data2.push(0);
           data1.push(0);
         }
      }
      this.yLabels = newYLabels.reverse();
     }else if(value === 'Month') {
       this.max = 100;
      this.stepSize = 20;
      let date = dayjs().tz("Asia/Taipei").startOf('month');
      let statRefs = db.collection("monthly");
      let start = dayjs().tz("Asia/Taipei").subtract(13,'month');
      let end = dayjs().tz("Asia/Taipei").subtract(1,'month');
      statRefs = statRefs.where("date", ">=", start.format('YYYY-MM-DD'));
      statRefs = statRefs.where("date", "<=", end.format('YYYY-MM-DD'));
      statRefs = statRefs.orderBy("date", "asc");
      let data = {};
      let allCol = await statRefs.get();
      allCol.forEach(function(doc){
        let daily = doc.data();
        data[dayjs(daily.date, "YYYY-MM-DD").format('YY/M/D')] = daily;
      });
       for(let i = 1 ; i < 13; i++){
         let label = date.subtract(i, 'month').format('YY/M/D');
         newYLabels.push(label);
          if(data[label]){
           data3.push(data[label].visitors);
           data2.push(data[label].requests);
           data1.push(data[label].downloads);
         }else{
           data3.push(0);
           data2.push(0);
           data1.push(0);
         }
       }
       this.yLabels = newYLabels.reverse();
     }
     this.datasets = [
        {
          label: 'Visitors',
          backgroundColor: hexToRgba(brandDanger, 50),
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 2,
          data: data3.reverse()
        },
        {
          label: 'Requests',
          backgroundColor: 'transparent',
          borderColor: brandSuccess,
          pointHoverBackgroundColor: brandSuccess,
          borderWidth: 2,
          data: data2.reverse()
        },
        {
          label: 'Downloads',
          backgroundColor: 'transparent',
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: data1.reverse()
        }
      ]
    }
  },
  methods: {
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    }
  }
}
</script>
